// extracted by mini-css-extract-plugin
module.exports = {"customFormItem":"CustomFormItem_customFormItem__NEiNm","label":"CustomFormItem_label__2YQJX","hasValue":"CustomFormItem_hasValue__3QRFZ"};